import React from 'react';
import { designTokens } from '../../constants/designTokens';

interface StatusMessageProps {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  className?: string;
  style?: React.CSSProperties;
}

export const StatusMessage = React.memo(function StatusMessage({
  type,
  message,
  className = '',
  style,
}: StatusMessageProps) {
  const typeStyles = {
    success: {
      backgroundColor: designTokens.colors.withOpacity.successLight,
      color: designTokens.colors.semantic.success,
      borderColor: designTokens.colors.semantic.success,
    },
    error: {
      backgroundColor: designTokens.colors.withOpacity.errorLight,
      color: designTokens.colors.semantic.error,
      borderColor: designTokens.colors.semantic.error,
    },
    warning: {
      backgroundColor: designTokens.colors.withOpacity.warningLight,
      color: designTokens.colors.semantic.warning,
      borderColor: designTokens.colors.semantic.warning,
    },
    info: {
      backgroundColor: designTokens.colors.withOpacity.brandLight,
      color: designTokens.colors.brand.primary,
      borderColor: designTokens.colors.brand.primary,
    },
  };

  return (
    <div
      className={`status-message status-message-${type} ${className}`}
      style={{
        padding: designTokens.spacing.md,
        borderRadius: designTokens.borderRadius.md,
        border: '1px solid',
        fontSize: designTokens.typography.fontSize.sm,
        lineHeight: 1.5,
        ...typeStyles[type],
        ...style,
      }}
    >
      {message}
    </div>
  );
});
